import { render, staticRenderFns } from "./airSettingsPopup.vue?vue&type=template&id=476bf8e8&scoped=true&"
import script from "./airSettingsPopup.vue?vue&type=script&lang=js&"
export * from "./airSettingsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476bf8e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476bf8e8')) {
      api.createRecord('476bf8e8', component.options)
    } else {
      api.reload('476bf8e8', component.options)
    }
    module.hot.accept("./airSettingsPopup.vue?vue&type=template&id=476bf8e8&scoped=true&", function () {
      api.rerender('476bf8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceAir/components/airSettingsPopup.vue"
export default component.exports